import lf from 'lovefield'

export function simu_echelons_simu_engins (schemaBuilder) {
  schemaBuilder.createTable('simu_echelons_simu_engins')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_echelons_id', lf.Type.INTEGER)
      .addColumn('const_phases_id', lf.Type.INTEGER)
      .addColumn('const_options_id', lf.Type.INTEGER)
      .addColumn('const_godets_id', lf.Type.INTEGER)
      .addColumn('simu_engins_id', lf.Type.INTEGER)
      .addColumn('const_famillesengins_const_options_const_phases_id', lf.Type.INTEGER)
      .addPrimaryKey(['id'], true) // true == autoincrement
      .addNullable(['const_famillesengins_const_options_const_phases_id', 'const_godets_id', 'const_options_id'])
        
      // .addIndex('constPhases_id', ['constPhases_id']);
      // .addIndex('constOptions_id', ['constOptions_id']);
      // .addIndex('simuEngins_id', ['simuEngins_id']);

}

/*

CREATE TABLE IF NOT EXISTS `simu-echelons_simu-engins` (
  `simu-echelons_id` int(11) NOT NULL,
  `const-phases_id` int(11) NOT NULL,
  `const-options_id` int(11) NOT NULL,
  `const-godets_id` int(11) NOT NULL,
  `simu-engins_id` int(11) NOT NULL,
  KEY `const-phases_id` (`const-phases_id`),
  KEY `const-options_id` (`const-options_id`),
  KEY `simu-engins_id` (`simu-engins_id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8;

*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuEchelons_simuEngins.schema.js